import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25.386",
  viewBox: "0 0 25 25.386"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "rxli8budtb" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M351.535 479.748a1.25 1.25 0 1 1 1.25 1.268 1.261 1.261 0 0 1-1.25-1.268m-2.5 0a3.75 3.75 0 1 0 3.751-3.809 3.78 3.78 0 0 0-3.751 3.809m10 0a1.25 1.25 0 1 1 1.25 1.268 1.261 1.261 0 0 1-1.25-1.268m-2.5 0a3.751 3.751 0 1 0 3.751-3.809 3.78 3.78 0 0 0-3.751 3.809m-10 8.8v-8.563a10 10 0 0 1 20 0v8.563a1.26 1.26 0 1 1-2.521 0 1.263 1.263 0 0 0-1.254-1.27c-.69 0-1.25.824-1.25 1.525s-.562 1.525-1.252 1.525h-1.25c-.691 0-1.248-.824-1.248-1.525a1.377 1.377 0 0 0-1.25-1.4 1.439 1.439 0 0 0-1.25 1.46 1.44 1.44 0 0 1-1.25 1.462h-1.25c-.693 0-1.25-.824-1.25-1.525a1.377 1.377 0 0 0-1.25-1.4 1.205 1.205 0 0 0-1.25 1.2 1.22 1.22 0 0 1-1.236 1.237 1.274 1.274 0 0 1-1.234-1.3m-2.5-8.563v9.832c0 1.4 1.091 3.049 2.47 3.049h.92a2.616 2.616 0 0 0 1.866-1.033 1.366 1.366 0 0 1 .964-.593c.389 0 .735.374.962.658a2.551 2.551 0 0 0 1.866.967h.622a2.605 2.605 0 0 0 1.848-1.018 1.366 1.366 0 0 1 .952-.581c.383 0 .723.37.95.648a2.535 2.535 0 0 0 1.846.951h.652a2.605 2.605 0 0 0 1.848-1.018 1.366 1.366 0 0 1 .952-.581c.385 0 .723.37.95.648a2.537 2.537 0 0 0 1.844.951h.954c1.381 0 2.529-1.646 2.529-3.049v-9.832a12.5 12.5 0 1 0-25 0",
      transform: "translate(-344.035 -467.479)"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", { style: {"clip-path":"url(#rxli8budtb)"} }, [
  /*#__PURE__*/_createElementVNode("path", {
    transform: "translate(-7.353 -7.469)",
    d: "M0 0h39.708v40.323H0z",
    style: {"fill":"var(--gp-icon-fill)"}
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }